import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.4rem;

  .label {
    display: flex;
    flex-direction: row;
    color: var(--primary_color);
    font-weight: 500;
  }

  .label-input {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-left: 1.4rem;
    border: 1px solid var(--blue);
    border-radius: 0.2rem;
    background-color: var(--white);
    height: 2.4rem;
    font-size: 0.9rem;

    &.right {
      justify-content: space-between;
    }

    .name {
      font-size: 0.9rem;
      font-weight: 700;
      color: var(--primary_color);
    }

    .placeholder {
      font-weight: 500;
      color: var(--gray_medium);
    }
  }

  input {
    width: 100%;
    height: 2.4rem;
    font-size: 0.9rem;
    padding-left: 1.4rem;
    font-weight: 500;
    border: 0;
    border-radius: 0.6rem;
  }

  input[type='file'] {
    display: none;
  }

  .delete-file-icon {
    cursor: pointer;
    position: absolute;
    bottom: 0.8rem;
    right: 0.5rem;
    width: 0.7rem;
    height: 0.7rem;
  }

  img {
    margin-right: 1rem;
  }

  & + & {
    margin-top: 1rem;
  }
`;
